"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M1752.768 221.109C1532.646.986 1174.283.986 954.161 221.109l-838.588 838.588c-154.052 154.165-154.052 404.894 0 558.946 149.534 149.421 409.976 149.308 559.059 0l758.738-758.626c87.982-88.094 87.982-231.417 0-319.51-88.32-88.208-231.642-87.982-319.51 0l-638.796 638.908 79.85 79.849 638.795-638.908c43.934-43.821 115.539-43.934 159.812 0 43.934 44.047 43.934 115.877 0 159.812l-758.739 758.625c-110.23 110.118-289.355 110.005-399.36 0-110.118-110.117-110.005-289.242 0-399.247l838.588-838.588c175.963-175.962 462.382-176.188 638.909 0 176.075 176.188 176.075 462.833 0 638.908l-798.607 798.72 79.849 79.85 798.607-798.72c220.01-220.123 220.01-578.485 0-798.607",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconPaperclip = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconPaperclip, _Component);
  function IconPaperclip() {
    (0, _classCallCheck2.default)(this, IconPaperclip);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconPaperclip).apply(this, arguments));
  }
  (0, _createClass2.default)(IconPaperclip, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconPaperclip",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconPaperclip.displayName = "IconPaperclip";
  return IconPaperclip;
}(_react.Component);
exports.default = IconPaperclip;
IconPaperclip.glyphName = 'paperclip';
IconPaperclip.variant = 'Line';
IconPaperclip.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);